DialogController = App.loadClass 'core::Angular/DialogController'

class exports.SetupDialogController extends DialogController

    constructor: (@scope, @transitions, @rootScope, @repo, loader, $q, @state, hooks, @modal) ->
        super(@scope, @transitions)

        # dialog sizing stuff
        @scope.fullpage = true

        if not @scope.selected.crop?.lineups_id?
            @state.go('portal.ratings.setup')
            return

        # loading stuff
        loader.overMap 'Loading...'

        things_to_load = [
            @loadSeedCompanies(@scope.selected.crop)
            @loadTraitPackages(@scope.selected.crop)
            @loadTraitSuppliers()
            @loadTreatments(@scope.selected.crop)
            @loadProducts(@scope.selected.crop)
        ]
        $q.all(things_to_load).then (result) =>
            @recalculateActiveProducts()
            @setProductFullNames()
            loader.hideAll()
            hooks.afterLoad?(@scope)

        # this is just a static list, so it doesn't need to be on the scope
        @trait_suppliers = []

        # scope properties
        @scope.seed_companies = []
        @scope.trait_packages = []
        @scope.treatments = []
        @scope.products = []
        @scope.show_inactive_products = false

        # scope methods
        @scope.addTraitPackage = @addTraitPackage
        @scope.editTraitPackage = @editTraitPackage
        @scope.deleteTraitPackage = @deleteTraitPackage
        @scope.addTreatment = @addTreatment
        @scope.editTreatment = @editTreatment
        @scope.deleteTreatment = @deleteTreatment
        @scope.addProduct = @addProduct
        @scope.editProduct = @editProduct
        @scope.deactivateProduct = @deactivateProduct
        @scope.activateProduct = @activateProduct

        # don't need these
        delete @scope.cancel
        delete @scope.save

        delete @cancel
        delete @save


    showError: (msg) =>
        # TODO: show the error
        # for now we'll just alert it
        alert(msg)

    showLoadingError: (items, msg = null) =>
        if msg?
            # if there's a detailed message, include it
            msg = "Failed to load #{items}: #{msg}"
        else
            # otherwise just give a generic error
            msg = "Failed to load #{items}"

        @showError msg

    showActivationError: (item, activating, msg = null) =>
        action = if activating then 'activate' else 'deactivate'
        if msg?
            # if there's a detailed message, include it
            msg = "Failed to #{action} #{item}: #{msg}"
        else
            # otherwise just give a generic error
            msg = "Failed to #{action} #{item}"

        @showError msg

    ##################
    # Seed Companies #
    ##################

    loadSeedCompanies: (crop) =>
        promise = @repo.getSeedCompanies(crop.lineups_id).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Seed Companies', response.status?.msg)
                return
            @scope.seed_companies = response.data.seed_companies

        .catch (response) =>
            @showLoadingError('Seed Companies')

        return promise



    ##################
    # Trait Packages #
    ##################

    loadTraitPackages: (crop) =>
        promise = @repo.getTraitPackages(crop.lineups_id).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Trait Packages', response.status?.msg)
                return
            @scope.trait_packages = response.data.trait_packages

        .catch (response) =>
            @showLoadingError('Trait Packages')

        return promise

    loadTraitSuppliers: () =>
        promise = @repo.getTraitSuppliers().then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Trait Suppliers', response.status?.msg)
                return
            @trait_suppliers = response.data.trait_suppliers.map (trait) ->
                trait.is_divider = false
                return trait
            @trait_suppliers.push
                id: -1
                name: '---------------'
                is_real: false
                is_divider: true

        .catch (response) =>
            @showLoadingError('Trait Suppliers')

        return promise

    addTraitPackage: =>
        @openTraitPackageDialog()

    editTraitPackage: (trait_package) =>
        @openTraitPackageDialog(trait_package)

    openTraitPackageDialog: (trait_package = null) =>
        # open the Trait Package dialog
        dialog = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/portal/ratings/trait-packages/dialog'
            controller: 'Ratings.Controllers.TraitPackageDialogController'
            resolve:
                # I don't like that this has to be a function, but oh well
                'lineups_id': => return @scope.selected.crop.lineups_id
                'trait_package': => return trait_package
                'trait_suppliers': => return @trait_suppliers

        # handle the result
        dialog.result.then (saved_trait_package) =>
            if trait_package?
                # update the trait package
                $.extend(trait_package, saved_trait_package)
            else
                # check if there's an inactive trait package with the same name
                trait_package = _.head _.filter @scope.trait_packages,
                    name: saved_trait_package.name

                if trait_package?
                    # if there is, use it (merging will also reactivate it)
                    $.extend(trait_package, saved_trait_package)
                else
                    # otherwise add the trait package to the list
                    @scope.trait_packages.push(saved_trait_package)

            # make sure stuff is up to date
            @recalculateActiveProducts()
            @setProductFullNames()

    deleteTraitPackage: (trait_package) =>
        if trait_package.num_active > 0
            return

        # set up the scope for the Delete dialog
        del_scope = @scope.$new()
        del_scope.title = 'Delete Trait Package'
        del_scope.item_name = 'Trait Package'
        del_scope.delete = () =>
            return @repo.deleteTraitPackage @scope.selected.crop.lineups_id, trait_package

        dialog = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/portal/ratings/setup/delete-dialog'
            controller: 'DeleteDialogController'
            scope: del_scope

        # handle the result
        dialog.result.then () =>
            # set the trait package to inactive
            trait_package.active = false


    ##############
    # Treatments #
    ##############

    loadTreatments: (crop) =>
        promise = @repo.getTreatments(crop.lineups_id).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Treatments', response.status?.msg)
                return
            @scope.treatments = response.data.treatments

        .catch (response) =>
            @showLoadingError('Treatments')

        return promise

    addTreatment: =>
        @openTreatmentDialog()

    editTreatment: (treatment) =>
        @openTreatmentDialog(treatment)

    openTreatmentDialog: (treatment = null) =>
        # open the Treatment dialog
        dialog = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/portal/ratings/treatments/dialog'
            controller: 'Ratings.Controllers.TreatmentDialogController'
            resolve:
                # I don't like that this has to be a function, but oh well
                'lineups_id': => return @scope.selected.crop.lineups_id
                'treatment': => return treatment

        # handle the result
        dialog.result.then (saved_treatment) =>
            if treatment?
                # update the treatment
                $.extend(treatment, saved_treatment)
            else
                # check if there's an inactive treatment with the same name
                treatment = _.head _.filter @scope.treatments,
                    name: saved_treatment.name

                if treatment?
                    # if there is, use it (merging will also reactivate it)
                    $.extend(treatment, saved_treatment)
                else
                    # otherwise add the treatment to the list
                    @scope.treatments.push(saved_treatment)

            # make sure stuff is up to date
            @recalculateActiveProducts()
            # @setProductFullNames() # treatments don't affect product names

    deleteTreatment: (treatment) =>
        if treatment.num_active > 0
            return

        # set up the scope for the Delete dialog
        del_scope = @scope.$new()
        del_scope.title = 'Delete Treatment'
        del_scope.item_name = 'Treatment'
        del_scope.delete = () =>
            return @repo.deleteTreatment @scope.selected.crop.lineups_id, treatment

        dialog = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/portal/ratings/setup/delete-dialog'
            controller: 'DeleteDialogController'
            scope: del_scope

        # handle the result
        dialog.result.then () =>
            # set the treatment to inactive
            treatment.active = false


    ############
    # Products #
    ############

    loadProducts: (crop) =>
        promise = @repo.getProducts(crop.lineups_id).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Products', response.status?.msg)
                return
            @scope.products = response.data.products

        .catch (response) =>
            @showLoadingError('Products')

        return promise

    # the Add Product and Edit Product dialog have different controllers, so
    # that's why they have different methods here
    addProduct: =>
        scope = @scope.$new(true)
        # need access to these properties and functions
        scope.seed_companies = @scope.seed_companies
        scope.trait_packages = @scope.trait_packages
        scope.existing_products = @scope.products
        scope.addSeedCompany = @addSeedCompany
        scope.addTraitPackage = @addTraitPackage

        # open the Add Product dialog
        dialog = @modal.open
            windowClass: 'product-dialog'
            templateUrl: 'backend/portal/ratings/products/add-dialog'
            controller: 'Ratings.Controllers.AddProductDialogController'
            scope: scope
            resolve:
                # I don't like that this has to be a function, but oh well
                'lineups_id': => return @scope.selected.crop.lineups_id

        # handle the result - this is unusual because the user can add multiple
        # products at once, so saved_products will always be an array
        dialog.result.then (saved_products) =>
            # add the product(s) to the list
            $.merge @scope.products, saved_products

            # make sure stuff is up to date
            @recalculateActiveProducts()
            @setProductFullNames()

            @rootScope.$broadcast 'ratings.add-product:saved',
                saved_products: saved_products
        , =>
            # if the dialog was cancelled
            @rootScope.$broadcast 'ratings.add-product:cancelled', {}

    editProduct: (product) =>
        scope = @scope.$new(true)
        # need access to these properties and functions
        scope.seed_companies = @scope.seed_companies
        scope.trait_packages = @scope.trait_packages
        scope.existing_products = @scope.products
        scope.addSeedCompany = @addSeedCompany
        scope.addTraitPackage = @addTraitPackage

        # open the Edit Product dialog
        dialog = @modal.open
            windowClass: 'product-dialog'
            templateUrl: 'backend/portal/ratings/products/edit-dialog'
            controller: 'Ratings.Controllers.EditProductDialogController'
            scope: scope
            resolve:
                # I don't like that this has to be a function, but oh well
                'lineups_id': => return @scope.selected.crop.lineups_id
                'product': => return product

        # handle the result
        dialog.result.then (saved_product) =>
            # no need to check whether product is set - the user can only ever
            # edit exactly one product at a time
            $.extend(product, saved_product)

            # make sure stuff is up to date
            @recalculateActiveProducts()
            @setProductFullNames()

    activateProduct: (product) =>
        @repo.activateProduct(@scope.selected.crop.lineups_id, product).then (response) =>
            if response.status?.type isnt 'success'
                @showActivationError('Product', true, response.status?.msg)
                return

            # activate the product
            product.active = true

            # make sure the seed company exists
            if response.data.seed_company?
                # check if there's a seed company that matches
                seed_company = _.head _.filter @scope.seed_companies,
                    id: response.data.seed_company.id

                if seed_company?
                    # if there is, do nothing - it already exists
                else
                    # if there isn't, add it to the list
                    @scope.seed_companies.push(response.data.seed_company)

            # make sure the trait package is active
            if response.data.trait_package?
                # check if there's an inactive trait package that matches
                trait_package = _.head _.filter @scope.trait_packages,
                    id: response.data.trait_package.id

                if trait_package?
                    # if there is, activate it
                    trait_package.active = true
                else
                    # if for some reason there isn't, add it to the list
                    @scope.trait_packages.push(response.data.trait_package)

            # make sure stuff is up to date
            @recalculateActiveProducts()
            @setProductFullNames() # no need to update names

        .catch (response) =>
            @showActivationError('Product', true, response.status?.msg)

    deactivateProduct: (product) =>
        @repo.deactivateProduct(@scope.selected.crop.lineups_id, product).then (response) =>
            if response.status?.type isnt 'success'
                @showActivationError('Product', false, response.status?.msg)
                return

            # deactivate the product. no need for a confirmation
            product.active = false

            # make sure stuff is up to date
            @recalculateActiveProducts()
            # @setProductFullNames() # no need to update names

        .catch (response) =>
            @showActivationError('Product', false, response.status?.msg)

    recalculateActiveProducts: =>
        # TODO: this should probably be done with watched/computed variables
        # instead of being a function that must be explicitly called

        # counts for seed companies
        for sc in @scope.seed_companies
            sc.num_active = _.filter @scope.products,
                seed_companies_id: sc.id
                active: true
            .length

        # counts for trait packages
        for tp in @scope.trait_packages
            tp.num_active = _.filter @scope.products,
                trait_packages_id: tp.id
                active: true
            .length

        # counts for treatments
        for tmt in @scope.treatments
            tmt.num_active = _.filter @scope.products, (product) =>
                return product.active and _.includes product.treatment_options, tmt.id
            .length

    setProductFullNames: =>
        for p in @scope.products
            sc = _.head _.filter @scope.seed_companies, id: p.seed_companies_id
            tp = _.head _.filter @scope.trait_packages, id: p.trait_packages_id

            p.full_name = "#{sc?.name} #{p.name} #{tp?.suffix}".trim()
